import React from 'react';
import styled from 'styled-components';
import { Anchor, Image, NavigationModule } from 'UI-Dash-Commons-UI';

import { DOCS_BOTTOM_MENU_TITLE } from "../constants/constants";
import DocsMenuSection from "../types/DocsMenuSection";


type BottomLeftMenuComponentProps =
    {
        menu: Array<DocsMenuSection>
    };

const BottomLeftMenuComponent: React.FunctionComponent<BottomLeftMenuComponentProps> = ( props ) =>
{
    if ( !props.menu || props.menu.length === 0 )
    {
        return <FooterWrapper/>;
    }

    return (
        <FooterWrapper>
            <FooterMenuHeader>
                {DOCS_BOTTOM_MENU_TITLE}
            </FooterMenuHeader>

            <FooterMenuList>
                {
                    props.menu.map( ( menuSection: DocsMenuSection ) =>
                    {
                        // special case for one trust cookies settings: https://app.asana.com/0/837882251489382/1202214124500791
                        if ( menuSection.url === NavigationModule.constants.ONE_TRUST_SDK_URL )
                        {
                            return <FooterMenuItem key={menuSection.id}>
                                <NavigationModule.components.OneTrustSDKButton/>
                            </FooterMenuItem>;
                        }

                        return (
                            <FooterMenuItem
                                key={menuSection.id}
                            >
                                <FooterMenuItemWrapper>
                                    <FooterMenuLink
                                        href={menuSection.url}
                                        id={menuSection.id}
                                        rel='noopener noreferrer'
                                        target="_blank"
                                        text={menuSection.displayName}
                                    />
                                    {
                                        menuSection.icon &&
                                        <FooterMenuLinkIcon src={menuSection.icon.iconSrc}
                                                            alt={menuSection.icon.iconAlt}/>
                                    }
                                </FooterMenuItemWrapper>
                            </FooterMenuItem>
                        );
                    } )
                }
            </FooterMenuList>
        </FooterWrapper>
    );
};

export default BottomLeftMenuComponent;

const FooterWrapper = styled.div`
  height: 116px;
  width: 300px;

  display: block;
  position: fixed;
  bottom: 0;
  
  background-color: #F1F4F5;
`;

const FooterMenuHeader = styled.div`
  margin-top: 1.5rem;
  margin-bottom: 1rem;
  padding-left: 1rem;
  
  color: #B8BABC;
  
  font-family: ${props => props.theme.fonts.regular};
  font-size: 12px;
`;

const FooterMenuList = styled.ul`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: left;
  
  width: 180px;

  margin: 10px 0 10px 0;
  padding-left: 1rem;

  list-style: none;
`;

const FooterMenuItem = styled.li`
  display: inline;
  margin-bottom: 15px;
  margin-right: 10px;
`;

const FooterMenuLink = styled( Anchor )`
  color: ${props => props.theme.colors.footerLinkGray};
  text-decoration: none;

  font-family: ${props => props.theme.fonts.regular};
  font-size: 11px;
`;

const FooterMenuItemWrapper = styled.span`
  display: flex;
    
  width: max-content;
`;

const FooterMenuLinkIcon = styled( Image )`
  width: 100%;
  max-width: 26px;
  max-height: 42px;
  margin-left: 3px;
`;

